import { getEntityRef } from "@client/content/lib/helper";
import { withIsVisible } from "@client/hocs";
import { type EntityRef } from "@client/types";
import * as React from "react";
import First from "./First/container";
import Second from "./Second/container";

import "./style.less";

export type MapProps = EntityRef & {
  isVisible: boolean;
  step: number;
};

export interface ActionProps {}

export default withIsVisible((props: ActionProps & MapProps) => (
  <>
    {props.step === 1 && <First {...getEntityRef(props)} />}
    {props.step === 2 && <Second {...getEntityRef(props)} />}
  </>
));
